import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export default class extends Controller {
    static values = {
        slidesPerView: Number,  // Allow slidesPerView as a configurable value
        mdSlides: Number,       // Set slidesPerView for md screens
        lgSlides: Number,       // Set slidesPerView for lg screens
    };

    connect() {

        this.swiper = new Swiper(this.element, {
            modules: [Navigation, Pagination],
            slidesPerView: this.slidesPerViewValue || 2,  // Default to 1 if not set
            observer: true,
            spaceBetween: 15,
            observeParents: true,
            breakpoints: {
                768: { slidesPerView: this.mdSlidesValue || 2 }, // Default to 1 at md
                992: { slidesPerView: this.lgSlidesValue || 2 }, // Default to 2 at lg
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}"></span>`;
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
}